import { useEffect } from 'react';
import { canPromptOnUnload } from '../lib/desktopShell';

/**
 * While `when` is true, asks before the page unloads: tab or window close, reload, a typed
 * address, and in the desktop shell also quit and the update banner's Restart now. The
 * prompt is the browser's, or the desktop shell's Leave / Stay dialog.
 *
 * Registers nothing where the unload cannot prompt (an older desktop shell; see
 * canPromptOnUnload), where cancelling would block the close without asking. Every page
 * that asks before unloading goes through this hook.
 */
export default function useBeforeUnloadPrompt(when) {
  useEffect(() => {
    if (!when || !canPromptOnUnload()) return undefined;
    const onBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [when]);
}
